import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaChevronDown } from 'react-icons/fa';
import '../styles/FAQ.css';

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: '¿El entrenamiento queda grabado?',
      answer:
        'No. Este es un sprint 100% en vivo, enfocado en ejecución real. No hay grabaciones porque el valor está en ver el proceso en tiempo real, no en consumir contenido pasivamente.',
    },
    {
      question: '¿Sirve si no tengo experiencia en trading?',
      answer:
        'Sí, siempre que tengas la disposición de aprender con criterio. Incluye un PDF de nivelación para principiantes, para que puedas seguir el sprint sin perderte.',
    },
    {
      question: '¿Sirve si ya tengo años en trading?',
      answer:
        'Sí. Este sprint está diseñado para traders que llevan tiempo operando pero no han logrado consistencia y necesitan claridad profesional, no más indicadores.',
    },
    {
      question: '¿Existe garantía de rentabilidad?',
      answer:
        'No. Nadie serio puede prometer rentabilidad. Lo que sí obtendrás es claridad, proceso y criterio para decidir si el trading es para ti.',
    },
    {
      question: '¿Cuánto capital necesito para aplicar lo aprendido?',
      answer:
        'Para aprovechar correctamente el sprint se recomienda contar con mínimo 100 USD para educación y 100 USD para una cuenta operativa (200 USD en total).',
    },
    {
      question: '¿Para quién es este entrenamiento?',
      answer:
        'Este sprint es para personas que están dispuestas a invertir al menos 100 USD en educación y 100 USD en una cuenta operativa. Quieren operar sin emociones, de forma mecánica y estructurada. Buscan seguir reglas claras, como lo hace un gestor de fondos, no improvisar.',
    },
    {
      question: '¿Este entrenamiento es para todo el mundo?',
      answer:
        'No. No es para quienes buscan señales, promesas rápidas o fórmulas mágicas. Es para quienes quieren criterio, proceso y claridad real.',
    },
    {
      question: '¿Qué pasa si se agotan los cupos?',
      answer:
        'El sprint se dicta solo en enero por agenda limitada. Una vez se agotan los cupos, no se habilitan más accesos.',
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.4 },
    },
  };

  return (
    <motion.div
      className="faq-container"
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
    >
      {faqs.map((faq, index) => (
        <motion.div key={index} className="faq-item" variants={itemVariants}>
          <button
            className={`faq-question ${activeIndex === index ? 'active' : ''}`}
            onClick={() => setActiveIndex(activeIndex === index ? null : index)}
          >
            <span>{faq.question}</span>
            <FaChevronDown
              className={`faq-icon ${activeIndex === index ? 'rotated' : ''}`}
            />
          </button>

          <motion.div
            className="faq-answer-container"
            initial={{ height: 0, opacity: 0 }}
            animate={{
              height: activeIndex === index ? 'auto' : 0,
              opacity: activeIndex === index ? 1 : 0,
            }}
            transition={{ duration: 0.3 }}
          >
            <div className="faq-answer">{faq.answer}</div>
          </motion.div>
        </motion.div>
      ))}

      <motion.div className="faq-cta" variants={itemVariants}>
        <p className="cta-text">Cierra este año con claridad.</p>
        <p className="cta-emphasis">Empieza 2026 con criterio profesional.</p>
        <button 
          className="cta-button-faq"
          onClick={() => window.location.href = '#pricing'}
        >
          👉 Asegurar mi cupo por $99 USD
        </button>
      </motion.div>
    </motion.div>
  );
};

export default FAQ;
